"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledRecaptchaError = exports.StyledRecaptcha = void 0;
var _mui = require("@ori-ui/mui");
const StyledRecaptcha = exports.StyledRecaptcha = (0, _mui.styled)(_mui.Stack)((param)=>{
    let { theme } = param;
    return {
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start'
        }
    };
});
const StyledRecaptchaError = exports.StyledRecaptchaError = (0, _mui.styled)(_mui.Stack)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.error.main,
        fontSize: '1.2rem',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start'
        }
    };
});
